import {Injectable, Signal} from '@angular/core';
import {Observable, startWith} from 'rxjs';
import {
    LangChangeEvent,
    MissingTranslationHandler,
    TranslateCompiler,
    TranslateLoader,
    TranslateParser,
    TranslateService,
    TranslateStore
} from '@ngx-translate/core';
import {map} from "rxjs/operators";
import {toSignal} from "@angular/core/rxjs-interop";

@Injectable({
    providedIn: 'root'
})
export class CustomTranslateService extends TranslateService {

    constructor(
        store: TranslateStore,
        loader: TranslateLoader,
        compiler: TranslateCompiler,
        parser: TranslateParser,
        missingTranslationHandler: MissingTranslationHandler
    ) {
        // Asetetaan oletusarvoina: käytä oletuskielen käännöstä, ei käytetä eristettyä storea, ei extenda
        super(store, loader, compiler, parser, missingTranslationHandler, true, false, false, 'fi');
    }


    public readonly current: Signal<string> = toSignal(
        this.onLangChange
            .pipe(
                map((langChangeEvent: LangChangeEvent)=> langChangeEvent.lang),
                startWith(this.currentLang ?? this.defaultLang)
            )
    )

    /**
     * Ylikirjoitetaan use-metodi:
     * - Tallentaa valitun kielen localStorageen
     * - Kutsuu alkuperäisen logiikan
     */
    override use(lang: string): Observable<any> {
        localStorage.setItem('locale', lang);
        return super.use(lang);
    }
}
